import { projectTemplate, arrayOfProjectTemplates } from "~/schemas/schema.project_templates.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import * as trashActions from "./actions.trash.jsx";

export const addTemplate = (attributes) => {
  return {
    types: [
      actionTypes.ADD_PROJECT_TEMPLATE_LOADING,
      actionTypes.ADD_PROJECT_TEMPLATE_SUCCESS,
      actionTypes.ADD_PROJECT_TEMPLATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      schema: {
        single: projectTemplate,
      },
    },
  };
};

export const fetchTemplate = (id) => {
  const url = `${Angie.api_url}/project-templates/${id}`;
  return {
    types: [
      actionTypes.FETCH_PROJECT_TEMPLATE_LOADING,
      actionTypes.FETCH_PROJECT_TEMPLATE_SUCCESS,
      actionTypes.FETCH_PROJECT_TEMPLATE_ERROR,
    ],
    callAPI: () => fetch({ url }),
    payload: {
      id,
      schema: {
        single: projectTemplate,
      },
    },
    cache: {
      key: url,
    },
  };
};

export const editTemplate = (id, attributes) => {
  return {
    types: [
      actionTypes.EDIT_PROJECT_TEMPLATE_LOADING,
      actionTypes.EDIT_PROJECT_TEMPLATE_SUCCESS,
      actionTypes.EDIT_PROJECT_TEMPLATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates/${id}`,
        method: "PUT",
        body: attributes,
      }),
    payload: {
      id,
      schema: {
        single: projectTemplate,
      },
    },
  };
};

export const reorderTemplateTaskLists = (id, order) => {
  return {
    types: [
      actionTypes.REORDER_PROJECT_TEMPLATE_LISTS_LOADING,
      actionTypes.REORDER_PROJECT_TEMPLATE_LISTS_SUCCESS,
      actionTypes.REORDER_PROJECT_TEMPLATE_LISTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates/${id}/reorder`,
        method: "PUT",
        body: order,
      }),
    payload: {
      id,
    },
  };
};

export const fetchTemplates = () => {
  return {
    types: [
      actionTypes.FETCH_PROJECT_TEMPLATES_LOADING,
      actionTypes.FETCH_PROJECT_TEMPLATES_SUCCESS,
      actionTypes.FETCH_PROJECT_TEMPLATES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates`,
      }),
    payload: {
      schema: arrayOfProjectTemplates,
    },
  };
};

export const moveToTrash = (id) => {
  const objectType = "ProjectTemplate";
  return {
    ...trashActions.moveToTrash(objectType, id),
    types: [
      actionTypes.MOVE_PROJECT_TEMPLATE_TO_TRASH_LOADING,
      actionTypes.MOVE_PROJECT_TEMPLATE_TO_TRASH_SUCCESS,
      actionTypes.MOVE_PROJECT_TEMPLATE_TO_TRASH_ERROR,
    ],
    payload: {
      id,
      objectType,
      schema: {
        single: projectTemplate,
      },
    },
  };
};

export const duplicateProjectTemplate = (id, attributes) => {
  return {
    types: [
      actionTypes.DUPLICATE_PROJECT_TEMPLATE_LOADING,
      actionTypes.DUPLICATE_PROJECT_TEMPLATE_SUCCESS,
      actionTypes.DUPLICATE_PROJECT_TEMPLATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates/${id}/duplicate`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      schema: {
        single: projectTemplate,
      },
    },
  };
};

export const projectTemplateCreatedFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: projectTemplate,
    id: data.id,
  };
};

export const projectTemplateUpdatedFromEventStream = (data) => {
  return {
    type: actionTypes.EDIT_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: projectTemplate,
    id: data.id,
  };
};

export const projectTemplateMovedToTrashFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_TEMPLATE_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: projectTemplate,
    id: data.id,
  };
};

export const projectTemplateRestoredFromTrashFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_TEMPLATE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: projectTemplate,
    id: data.id,
  };
};
